module.exports = __webpack_public_path__ + "img/Court-Attendance.6a17edab.png";